export enum RoomStates {
    WithAdvisor = 'withAdvisor',
    Ended = 'ended',
    ReadyForAdvisor = 'readyForAdvisor',
    Registered = 'registered',
    WithBot = 'withBot'
}
